import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import { Editor } from "@tinymce/tinymce-react";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";

import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditModel({
  backUrl,
  api,
  fetchData,
  getType,
  getOrientation,
  getCategory,
  handleSubmit,
  getShow,
  showData,

  //render

  renderOuiNonOptions,
  renderOrientationOptions,
  renderTypeOptions,
  renderCategorieOptions,
  //Variable
  //actif
  selectedActif,
  handleActifChange,
  // typeDocument
  selectedType,
  handleTypeChange,
  // Nom modele
  selectedNomMod,
  handleNomModChange,
  // original
  selectedOriginal,
  handleOriginalChange,
  // fisc
  selectedFisc,
  handleFiscChange,
  // Transmission API
  selectedTransmissionAPI,
  handleTransmissionAPIChange,
  //Catégorie PME
  selectedCategorie,
  handleCategorieChange,
  // Balises
  selectedBalise,
  handleBaliseChange,
  // Cumul
  selectedCumul,
  handleCumulChange,
  // Commentaire
  selectedCommentaire,
  handleCommentaireChange,
  //Champs
  selectedChamps1,
  selectedChamps2,
  selectedChamps3,
  selectedChamps4,
  selectedChamps5,
  selectedChamps6,
  handleChamps1Change,
  handleChamps2Change,
  handleChamps3Change,
  handleChamps4Change,
  handleChamps5Change,
  handleChamps6Change,
  // Images
  selectedImage1,
  selectedImage2,
  selectedImage3,
  selectedImage4,

  handleImage1Change,
  handleImage2Change,
  handleImage3Change,
  handleImage4Change,
  //Nom du fichier global
  selectedNomGlobal,
  handleNomGlobalChange,
  //Nom Fichier Individuel
  selectedNomIndividuel,
  handleNomIndividuelChange,
  // Orientation
  selectedOrientation,
  handleOrientationChange,
  // Marge Haut
  selectedMargeHaut,
  handleMargeHautChange,
  // Marge Bas
  selectedMargeBas,
  handleMargeBasChange,
  // Marge Cote
  selectedMargeCote,
  handleMargeCoteChange,
  // Hauteur de ligne
  selectedHauteurLigne,
  handleHauteurLigneChange,
  // Hauteur  pied
  selectedHauteurPied,
  handleHauteurPiedChange,
  //Largeur
  selectedLargeur,
  handleLargeurChange,
  //Tableau
  formSignature,
  onAddFormSignature,
  onDeleteFormSignature,
  handleInputChange,
  // variable données
  modelData,
  CaracteristiqueData,
  PresentationData,
  FiltresData,
  ChampsImpressionData,
  ImagesData,
  CommentaireData,
  // COntenu
  selectedContent,
  handleContentChange,
  setContent,
  selectedHeader,
  handleHeaderChange,
  selectedFooter,
  handleFooterChange,

  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  colStyle,
  toggleTooltip,
  tooltipOpen,
  toggleTooltip1,
  tooltipOpen1,
  toggleTooltip2,
  tooltipOpen2,
  toggleTooltip3,
  tooltipOpen3,
  toggleTooltip4,
  tooltipOpen4,
  toggleTooltip5,
  tooltipOpen5,
  toggleTooltip6,
  tooltipOpen6,
  toggleTooltip7,
  tooltipOpen7,
  toggleTooltip8,
  tooltipOpen8,
  toggleTooltip9,
  tooltipOpen9,
  toggleTooltip10,
  tooltipOpen10,
}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      handleContentChange(editorRef.current.getContent());
    }
  };
  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAsync();
  }, []);

  useEffect(() => {
    if (!loading) {
      getType();
      getOrientation();
      getCategory();
    }
  }, [loading]);
  useEffect(() => {
    getShow();
    console.log(showData);
  }, [selectedType]);

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#3c88c8",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Titre
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-info"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Caractéristiques
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(CaracteristiqueData).map(
                                      ([key, value], index) => (
                                        <Row className="mb-3" key={index}>
                                          {key === "Document type" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedType}
                                                  onChange={handleTypeChange}
                                                  options={renderTypeOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedType === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Document type ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Original" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedOriginal
                                                  }
                                                  onChange={
                                                    handleOriginalChange
                                                  }
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Nom du modèle" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedNomMod}
                                                  required
                                                  onChange={handleNomModChange}
                                                />
                                                {selectedNomMod === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Nom du modèle ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Actif" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedActif}
                                                  onChange={handleActifChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedActif === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Actif ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "A transmettre au fisc" &&
                                            showData == true ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedFisc}
                                                  onChange={handleFiscChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Transmission API CGP" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedTransmissionAPI
                                                  }
                                                  onChange={
                                                    handleTransmissionAPIChange
                                                  }
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Liste des balises disponibles" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8"></Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      )
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Filtres / Cumul
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(FiltresData).map(
                                      ([key, value], index) => (
                                        <Row className="mb-3" key={index}>
                                          {key ===
                                          "Balises non nulle pour impression" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}
                                                    <i
                                                      className="bx bx-info-circle"
                                                      style={{
                                                        marginLeft: "5px",
                                                        cursor: "pointer",
                                                        color: "black",
                                                      }}
                                                      id="Balise"
                                                      onMouseEnter={
                                                        toggleTooltip2
                                                      }
                                                      onMouseLeave={
                                                        toggleTooltip2
                                                      }
                                                    />
                                                    <Tooltip
                                                      placement="top"
                                                      isOpen={tooltipOpen2}
                                                      target="Balise"
                                                      toggle={toggleTooltip2}
                                                    >
                                                      {
                                                        modelData
                                                          ?.detail_publipostage
                                                          ?.helpers[
                                                          "Balises non nulle pour impression"
                                                        ]
                                                      }
                                                    </Tooltip>{" "}
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedBalise}
                                                  required
                                                  onChange={handleBaliseChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Catégorie de PME" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedCategorie
                                                  }
                                                  onChange={
                                                    handleCategorieChange
                                                  }
                                                  options={renderCategorieOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedCategorie === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Catégorie de PME ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Cumul par investisseur" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedCumul}
                                                  onChange={handleCumulChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedCumul === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Cumul par investisseur ne
                                                    peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : null}{" "}
                                        </Row>
                                      )
                                    )}
                                  </CardBody>
                                </Card>
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        {" "}
                                        Commentaires
                                      </CardTitle>
                                      <CardBody>
                                        {Object.entries(CommentaireData).map(
                                          ([key, value], index) => (
                                            <Row className="mb-3" key={index}>
                                              {key === "Commentaires" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedCommentaire
                                                      }
                                                      required
                                                      onChange={
                                                        handleCommentaireChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                            </Row>
                                          )
                                        )}
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Présentation / sortie
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(PresentationData).map(
                                      ([key, value], index) => (
                                        <Row className="mb-3" key={index}>
                                          {key === "Nom du fichier global" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}*:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedNomGlobal
                                                  }
                                                  required
                                                  onChange={
                                                    handleNomGlobalChange
                                                  }
                                                />
                                                {selectedNomGlobal === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Nom du fichier global ne
                                                    peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Nom des fichiers individuels" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}
                                                    {"*"}
                                                    <i
                                                      className="bx bx-info-circle"
                                                      style={{
                                                        marginLeft: "5px",
                                                        cursor: "pointer",
                                                        color: "black",
                                                      }}
                                                      id="nomFichierIndivInfoTooltip"
                                                      onMouseEnter={
                                                        toggleTooltip
                                                      }
                                                      onMouseLeave={
                                                        toggleTooltip
                                                      }
                                                    />
                                                    <Tooltip
                                                      placement="top"
                                                      isOpen={tooltipOpen}
                                                      target="nomFichierIndivInfoTooltip"
                                                      toggle={toggleTooltip}
                                                    >
                                                      {
                                                        modelData
                                                          ?.detail_publipostage
                                                          ?.helpers[
                                                          "Nom du fichier"
                                                        ]
                                                      }
                                                    </Tooltip>{" "}
                                                    :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedNomIndividuel
                                                  }
                                                  required
                                                  onChange={
                                                    handleNomIndividuelChange
                                                  }
                                                />
                                                {selectedNomIndividuel ===
                                                "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Nom des fichiers individuels
                                                    ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Marge haut (cm)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedMargeHaut
                                                  }
                                                  required
                                                  onChange={
                                                    handleMargeHautChange
                                                  }
                                                />
                                                {selectedMargeHaut === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Marge haut ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Marge bas (cm)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedMargeBas
                                                  }
                                                  required
                                                  onChange={
                                                    handleMargeBasChange
                                                  }
                                                />
                                                {selectedMargeBas === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Marge Bas ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Marge côtés (cm)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedMargeCote
                                                  }
                                                  required
                                                  onChange={
                                                    handleMargeCoteChange
                                                  }
                                                />
                                                {selectedMargeCote === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Marge côtés ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Largeur (px)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                      paddingTop: 10,
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedLargeur}
                                                  required
                                                  onChange={handleLargeurChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Hauteur pied de page" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedHauteurPied
                                                  }
                                                  required
                                                  onChange={
                                                    handleHauteurPiedChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Orientation" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                      paddingTop: 10,
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedOrientation
                                                  }
                                                  onChange={
                                                    handleOrientationChange
                                                  }
                                                  options={renderOrientationOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedOrientation ===
                                                null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Orientation ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Hauteur de ligne (em)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "9em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}
                                                    {"*"}
                                                    <i
                                                      className="bx bx-info-circle"
                                                      style={{
                                                        marginLeft: "5px",
                                                        cursor: "pointer",
                                                        color: "black",
                                                      }}
                                                      id="HauteurLigne"
                                                      onMouseEnter={
                                                        toggleTooltip4
                                                      }
                                                      onMouseLeave={
                                                        toggleTooltip4
                                                      }
                                                    />
                                                    <Tooltip
                                                      placement="top"
                                                      isOpen={tooltipOpen4}
                                                      target="HauteurLigne"
                                                      toggle={toggleTooltip4}
                                                    >
                                                      {
                                                        modelData
                                                          ?.detail_publipostage
                                                          ?.helpers[
                                                          "Hauteur de ligne (em)"
                                                        ]
                                                      }
                                                    </Tooltip>
                                                    :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedHauteurLigne
                                                  }
                                                  required
                                                  onChange={
                                                    handleHauteurLigneChange
                                                  }
                                                />
                                                {selectedHauteurLigne === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Hauteur de ligne ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      )
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                {Object.keys(ChampsImpressionData).length >
                                0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          {" "}
                                          Champs d'impression{" "}
                                        </CardTitle>

                                        <CardBody>
                                          {Object.entries(
                                            ChampsImpressionData
                                          ).map(([key, value], index) => (
                                            <Row className="mb-3" key={index}>
                                              {key === "Champ 1" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key}
                                                        <i
                                                          className="bx bx-info-circle"
                                                          style={{
                                                            marginLeft: "5px",
                                                            cursor: "pointer",
                                                            color: "black",
                                                          }}
                                                          id="champ1ToolTip"
                                                          onMouseEnter={
                                                            toggleTooltip1
                                                          }
                                                          onMouseLeave={
                                                            toggleTooltip1
                                                          }
                                                        />
                                                        <Tooltip
                                                          placement="top"
                                                          isOpen={tooltipOpen1}
                                                          target="champ1ToolTip"
                                                          toggle={
                                                            toggleTooltip1
                                                          }
                                                        >
                                                          {
                                                            modelData
                                                              ?.detail_publipostage
                                                              ?.helpers[
                                                              "Champ 1"
                                                            ]
                                                          }
                                                        </Tooltip>{" "}
                                                        :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedChamps1
                                                      }
                                                      required
                                                      onChange={
                                                        handleChamps1Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Champ 2" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedChamps2
                                                      }
                                                      required
                                                      onChange={
                                                        handleChamps2Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Champ 3" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedChamps3
                                                      }
                                                      required
                                                      onChange={
                                                        handleChamps3Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Champ 4" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedChamps4
                                                      }
                                                      required
                                                      onChange={
                                                        handleChamps4Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Champ 5" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedChamps5
                                                      }
                                                      required
                                                      onChange={
                                                        handleChamps5Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Champ 6" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedChamps6
                                                      }
                                                      required
                                                      onChange={
                                                        handleChamps6Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                                {Object.keys(ImagesData).length > 0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          {" "}
                                          Images{" "}
                                        </CardTitle>

                                        <CardBody>
                                          {Object.entries(ImagesData).map(
                                            ([key, value], index) => (
                                              <Row className="mb-3" key={index}>
                                                {key === "Image 1" ? (
                                                  <>
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          {key}{" "}
                                                          <i
                                                            className="bx bx-info-circle"
                                                            style={{
                                                              marginLeft: "5px",
                                                              cursor: "pointer",
                                                              color: "black",
                                                            }}
                                                            id="Image"
                                                            onMouseEnter={
                                                              toggleTooltip3
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip3
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={
                                                              tooltipOpen3
                                                            }
                                                            target="Image"
                                                            toggle={
                                                              toggleTooltip3
                                                            }
                                                          >
                                                            {
                                                              modelData
                                                                ?.detail_publipostage
                                                                ?.helpers[
                                                                "Image 1"
                                                              ]
                                                            }
                                                          </Tooltip>
                                                          :
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      {selectedImage1 !=
                                                      null ? (
                                                        <a
                                                          href={selectedImage1}
                                                        >
                                                          Voir l'image
                                                        </a>
                                                      ) : null}

                                                      <input
                                                        className="form-control form-control-sm"
                                                        type="file"
                                                        required
                                                        onChange={
                                                          handleImage1Change
                                                        }
                                                      />
                                                    </Col>
                                                  </>
                                                ) : null}
                                                {key === "Image 2" ? (
                                                  <>
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          {key} :
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      {selectedImage2 !=
                                                      null ? (
                                                        <a
                                                          href={selectedImage2}
                                                        >
                                                          Voir l'image
                                                        </a>
                                                      ) : null}
                                                      <input
                                                        className="form-control form-control-sm"
                                                        type="file"
                                                        onChange={
                                                          handleImage2Change
                                                        }
                                                      />
                                                    </Col>
                                                  </>
                                                ) : null}
                                                {key === "Image 3" ? (
                                                  <>
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          {key} :
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      {selectedImage3 !=
                                                      null ? (
                                                        <a
                                                          href={selectedImage3}
                                                        >
                                                          Voir l'image
                                                        </a>
                                                      ) : null}
                                                      <input
                                                        className="form-control form-control-sm"
                                                        type="file"
                                                        required
                                                        onChange={
                                                          handleImage3Change
                                                        }
                                                      />
                                                    </Col>
                                                  </>
                                                ) : null}
                                                {key === "Image 4" ? (
                                                  <>
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          {key} :
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      {selectedImage4 !=
                                                      null ? (
                                                        <a
                                                          href={selectedImage4}
                                                        >
                                                          Voir l'image
                                                        </a>
                                                      ) : null}
                                                      <input
                                                        className="form-control form-control-sm"
                                                        type="file"
                                                        required
                                                        onChange={
                                                          handleImage4Change
                                                        }
                                                      />
                                                    </Col>
                                                  </>
                                                ) : null}
                                              </Row>
                                            )
                                          )}
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                              </Col>
                            </Row>
                            <Row>
                              <Row>
                                <Col sm="12">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    Contenu
                                  </CardTitle>

                                  <CardBody>
                                    <Editor
                                      apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                      onInit={(evt, editor) =>
                                        (editorRef.current = editor)
                                      }
                                      initialValue={selectedContent}
                                      init={{
                                        height: 1000,
                                        menubar: true,
                                        plugins: [
                                          "advlist",
                                          "autolink",
                                          "lists",
                                          "link",
                                          "image",
                                          "charmap",
                                          "preview",
                                          "anchor",
                                          "searchreplace",
                                          "visualblocks",
                                          "code",
                                          "fullscreen",
                                          "insertdatetime",
                                          "media",
                                          "table",
                                          "code",
                                          "help",
                                          "wordcount",
                                          "autosave",
                                        ],
                                        toolbar:
                                          "undo redo | blocks | " +
                                          "bold italic forecolor | alignleft aligncenter " +
                                          "alignright alignjustify | bullist numlist outdent indent | " +
                                          "removeformat | help",
                                        content_style:
                                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                      }}
                                      onChange={(e) =>
                                        setContent(e.target.getContent())
                                      }
                                    />
                                    {Object.entries(
                                      modelData?.detail_publipostage?.[
                                        "Contenu"
                                      ]
                                    ).map(([key, value], index) => (
                                      <Row className="mb-3" key={index}>
                                        {key === "Header" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="mb-2 col-md-8">
                                              <input
                                                className="form-control"
                                                type="text"
                                                defaultValue={selectedHeader}
                                                required
                                                onChange={handleHeaderChange}
                                              />
                                            </Col>
                                          </>
                                        ) : null}
                                        {key === "Footer" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key} :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="mb-2 col-md-8">
                                              <input
                                                className="form-control"
                                                type="text"
                                                defaultValue={selectedFooter}
                                                required
                                                onChange={handleFooterChange}
                                              />
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Col>
                              </Row>
                              <Col sm="12">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingBottom: "10px" }}
                                >
                                  Signature électronique
                                  <i
                                    className="bx bx-info-circle"
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                      color: "black",
                                    }}
                                    id={"Signataires"}
                                    onMouseEnter={toggleTooltip8}
                                    onMouseLeave={toggleTooltip8}
                                  />
                                  <Tooltip
                                    placement="top"
                                    isOpen={tooltipOpen8}
                                    target={"Signataires"}
                                    toggle={toggleTooltip8}
                                  >
                                    {
                                      modelData?.detail_publipostage?.helpers[
                                        "Signataires"
                                      ]
                                    }
                                  </Tooltip>
                                </CardTitle>
                                <div className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        {modelData?.detail_publipostage?.[
                                          "Signature électronique"
                                        ]?.Signataires.header.map(
                                          (columnName, index) => (
                                            <th
                                              className="text-nowrap"
                                              style={tableaustyles}
                                              key={index}
                                            >
                                              {columnName}
                                              {columnName ===
                                              "Page signature" ? (
                                                <>
                                                  <i
                                                    className="bx bx-info-circle"
                                                    style={{
                                                      marginLeft: "5px",
                                                      cursor: "pointer",
                                                      color: "black",
                                                    }}
                                                    id={"Page-Signature"}
                                                    onMouseEnter={
                                                      toggleTooltip5
                                                    }
                                                    onMouseLeave={
                                                      toggleTooltip5
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen5}
                                                    target={"Page-Signature"}
                                                    toggle={toggleTooltip5}
                                                  >
                                                    {
                                                      modelData
                                                        ?.detail_publipostage
                                                        ?.helpers[
                                                        "Page signature"
                                                      ]
                                                    }
                                                  </Tooltip>
                                                </>
                                              ) : columnName ===
                                                "Position signature" ? (
                                                <>
                                                  <i
                                                    className="bx bx-info-circle"
                                                    style={{
                                                      marginLeft: "5px",
                                                      cursor: "pointer",
                                                      color: "black",
                                                    }}
                                                    id={"Position-Signature"}
                                                    onMouseEnter={
                                                      toggleTooltip6
                                                    }
                                                    onMouseLeave={
                                                      toggleTooltip6
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen6}
                                                    target={
                                                      "Position-Signature"
                                                    }
                                                    toggle={toggleTooltip6}
                                                  >
                                                    {
                                                      modelData
                                                        ?.detail_publipostage
                                                        ?.helpers[
                                                        "Position signature"
                                                      ]
                                                    }
                                                  </Tooltip>
                                                </>
                                              ) : columnName ===
                                                "Signataire" ? (
                                                <>
                                                  <i
                                                    className="bx bx-info-circle"
                                                    style={{
                                                      marginLeft: "5px",
                                                      cursor: "pointer",
                                                      color: "black",
                                                    }}
                                                    id={"Signataire"}
                                                    onMouseEnter={
                                                      toggleTooltip7
                                                    }
                                                    onMouseLeave={
                                                      toggleTooltip7
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen7}
                                                    target={"Signataire"}
                                                    toggle={toggleTooltip7}
                                                  >
                                                    {
                                                      modelData
                                                        ?.detail_publipostage
                                                        ?.helpers["Signataire"]
                                                    }
                                                  </Tooltip>
                                                </>
                                              ) : null}
                                            </th>
                                          )
                                        )}
                                        <th
                                          className="text-nowrap"
                                          style={tableaustyles}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {formSignature?.map((rowData) => (
                                        <tr key={rowData.index}>
                                          {Object.entries(rowData).map(
                                            ([key, value]) =>
                                              key !== "id" &&
                                              key !== "index" ? (
                                                <td key={key}>
                                                  {key === "page_signature" ||
                                                  key ===
                                                    "position_signature" ||
                                                  key === "signataire" ? (
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{
                                                        minWidth: "50px",
                                                      }}
                                                      defaultValue={value}
                                                      name={key}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          rowData.index,
                                                          e.target.name,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  ) : (
                                                    <span>{value}</span>
                                                  )}
                                                </td>
                                              ) : (
                                                <td
                                                  className="d-none"
                                                  key={key}
                                                >
                                                  <input
                                                    type="hidden"
                                                    size="10"
                                                    value={value}
                                                  />
                                                </td>
                                              )
                                          )}
                                          <td>
                                            <i
                                              className="bx bx-trash"
                                              style={{
                                                fontSize: "20px",
                                                paddingTop: "5px",
                                                textalign: "center",
                                                verticalalign: "middle",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                onDeleteFormSignature(
                                                  rowData.index
                                                )
                                              }
                                            ></i>
                                          </td>
                                        </tr>
                                      ))}
                                      <tr>
                                        <td colSpan="9">
                                          <input
                                            type="button"
                                            style={tableaustyles}
                                            className="btn btn-info mt-3 mt-lg-0"
                                            value="Ajouter"
                                            onClick={onAddFormSignature}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditModel;
